/* ADD GROUPS */
export const ADD_EXAM = "ADD_EXAM"
export const ADD_EXAM_SUCCESS = "ADD_EXAM_SUCCESS"
export const ADD_EXAM_CLEAN = "ADD_EXAM_CLEAN"
export const ADD_EXAM_ERROR = "ADD_EXAM_ERROR"
